import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";

interface IUpdateCategoryData {
  categoryName: string;
  displayName: string;
  isVisible: boolean;
}

const useUpdateCategory = () =>
  useMutation({
    mutationFn: async ({ data, id }: {
      data: IUpdateCategoryData;
      id: string
    }) => {
      const response = await AXIOS_RESERVATION.put(`/v1/updateCategory/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["services-components"] });
    },
  });

export default useUpdateCategory;